import React, { Component} from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import SetBeneficiary from '../pages/setBeneficiary'
import TransferForm from '../pages/transferForm'
import TransferFromForm from '../pages/transferFromForm'
import PromotToAdminForm from '../pages/promotToAdminForm'
import MintForm from '../pages/mintForm'
import IncreaseAllowanceForm from '../pages/increaseAllowanceForm'
import DecreaseAllowanceForm from '../pages/decreaseAllowanceForm'
import BurnFromForm from '../pages/burnFromForm'
import BurnForm from '../pages/burnForm'
import ApproveForm from '../pages/approveForm'
import TransferFromContractAddressForm from '../pages/transferFromContractAddressForm'
import { tokenSummary } from '../data'
import { removeExponents } from '../utils'
// import Particle from './Particle'
// import { aferAddress, seedAddress } from '../data'
// import AFER from '../../abi/AFER.json'
// import SeedSaleVesting from '../../abi/SeedSaleVesting.json'


class CustomSlideAdmin extends Component {
  render() {
    const { index, ...props } = this.props;
    return (
      <div {...props}></div>
    );

      
  }
}

export default class Responsive extends Component {


  constructor(props) {
    super(props);

    this.state = {
      initialSupply:0,
      totalAmountInCirculation:0,
      totalAmountSold:0,
      totalAmountReserved:0,
      additionalAmountMinted: 0
    }

    this.setData();
  }


  setData = async () => {
    let result = await tokenSummary();
    this.setState({
      initialSupply:removeExponents(result.initialSupply),
      totalAmountInCirculation:removeExponents(result.totalAmountInCirculation),
      totalAmountSold:removeExponents(result.totalAmountSold),
      totalAmountReserved:removeExponents(result.totalAmountReserved),
      additionalAmountMinted: removeExponents(result.additionalAmountMinted)
    });
  }

  render() {

  // function alertMe() {
  //   alert("Ok functions can work here")
  // }
    var settings = {
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      adaptiveHeight: 300,
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
    };


    return (
        <div className='nft-big'>
          <Slider {...settings}>
          <CustomSlideAdmin className='itm' index={1}>
              <div className="nft_pic" style={{padding:"40px 50px"}}>                            
                <h1>AFER TOKEN Summary</h1>
                <h4>Initial AFER Supplied : <span className="text-uppercase color">{this.state.initialSupply} AFER </span> </h4>
                <h4>Total Amount in Circulation : <span className="text-uppercase color">{this.state.totalAmountInCirculation} AFER</span></h4>
                <h4>Amount Sold : <span className="text-uppercase color">{this.state.totalAmountSold} AFER</span></h4>
                <h4>Amount Reserved : <span className="text-uppercase color">{this.state.totalAmountReserved} AFER</span></h4>
                <h4>Additional Amount Minted : <span className="text-uppercase color">{this.state.additionalAmountMinted} AFER</span></h4>
              </div>
            </CustomSlideAdmin>
            <CustomSlideAdmin className='itm' index={2}>
              <SetBeneficiary/>
            </CustomSlideAdmin>
            <CustomSlideAdmin className='itm' index={3}>
              <TransferForm/>
            </CustomSlideAdmin>
            <CustomSlideAdmin className='itm' index={4}>
              <PromotToAdminForm/>
            </CustomSlideAdmin>
            <CustomSlideAdmin className='itm' index={5}>
              <MintForm/>
            </CustomSlideAdmin>
            <CustomSlideAdmin className='itm' index={6}>
              <IncreaseAllowanceForm/>
            </CustomSlideAdmin>
            <CustomSlideAdmin className='itm' index={7}>
              <DecreaseAllowanceForm/>
            </CustomSlideAdmin>
            <CustomSlideAdmin className='itm' index={8}>
              <BurnFromForm/>
            </CustomSlideAdmin>
            <CustomSlideAdmin className='itm' index={9}>
              <BurnForm/>
            </CustomSlideAdmin>
            <CustomSlideAdmin className='itm' index={10}>
              <ApproveForm/>
            </CustomSlideAdmin>
            <CustomSlideAdmin className='itm' index={11}>
              <TransferFromContractAddressForm/>
            </CustomSlideAdmin>
            <CustomSlideAdmin className='itm' index={12}>
              <TransferFromForm/>
            </CustomSlideAdmin>
            {/* <CustomSlideAdmin className='itm' index={13}>
              <Particle/>
            </CustomSlideAdmin> */}
          </Slider>
        </div>
    );
  }
}
